// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A33xw","content":"styles_content__g7d0L","row":"styles_row__1PIHX","footer":"styles_footer__383xA","phraseLength":"styles_phraseLength__31-Ql"};